import useLayout from "@/hooks/useLayout";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../inputs/button";
import ButtonGroup from "../buttons/buttonGroup";
import Section from "../layout/section";
import Callout from "../callout/callout";
import ProcessingButton from "../inputs/processingButton";
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import useAccess from "@/hooks/useAccess";
import { decodeFirebaseError } from "utils/firebaseHelpers";

interface DeleteAccessDocFormProps {
    storageId: string;
    accessId: string;
}

const DeleteAccessDocForm: React.FC<DeleteAccessDocFormProps> = ({ storageId, accessId }) => {
    
    const { t } = useTranslation()

    const [errors, setErrors] = useState<string[]>([]);

    const {
        deleteInvitation,
        isDeleting
    } = useAccess({});

    const {
        closeDialog,
        addToast
    } = useLayout()

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setErrors([])

        try {
            await deleteInvitation({ storageId, accessId })
            closeDialog()
            addToast({ text: t('toastAccessDeleted'), colorScheme: 'green' })
        } catch (e: unknown) {
            const errorMessage = decodeFirebaseError(e instanceof Error ? e.message : String(e))
            setErrors([errorMessage])
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <Section>
                <p>{t('deleteAccessConfirmation')}</p>
                {errors.length > 0 && <Callout type="error">{errors.join(', ')}</Callout>}
                <ButtonGroup>
                    {isDeleting ? (
                        <ProcessingButton design="primary" />
                    ) : (
                        <>
                            <Button wideOnMobile type="button" onClick={closeDialog} design="optional"><CloseIcon /><span>{t('buttonCancel')}</span></Button>
                            <Button wideOnMobile type="submit" design="danger"><DeleteIcon /><span>{t('buttonDelete')}</span></Button>
                        </>
                    )}
                </ButtonGroup>
            </Section>
        </form>
    )
}

export default DeleteAccessDocForm
